import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CrudService } from 'src/app/demo/service/crud.service';
import { AlertsService } from 'src/app/demo/service/alerts.service';
import { Field } from 'src/app/demo/interfaces/form-print.interface';

@Component({
  selector: 'app-dialog-form-dynamic',
  templateUrl: './dialog-form-dynamic.component.html',
  styleUrl: './dialog-form-dynamic.component.scss'
})
export class DialogFormDynamicComponent implements OnInit {
  questions: Field[] = [];
  showButtonsForm: boolean = true;

  constructor(
    private crudService: CrudService,
    private alertService: AlertsService,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.questions = this.dynamicDialogConfig.data.questions;

    if (this.dynamicDialogConfig.data.formData) {
      this.questions.forEach(question => {
        for (const key in this.dynamicDialogConfig.data.formData) if (key === question.key) question.value = this.dynamicDialogConfig.data.formData[key];
      });
    }
    this.showButtonsForm = this.dynamicDialogConfig.data.hasOwnProperty('showButtonsForm') ? this.dynamicDialogConfig.data.showButtonsForm : true;
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2024-10-14
    * Metodo que realiza el submit del formulario emitido.
    * @param $event Formulario emitido por el componente hijo.
  */
  sendQuestions($event: FormGroup): void {
    if (this.dynamicDialogConfig.data.apiString) {
      if (!this.dynamicDialogConfig.data.formData) {
        this.crudService.postData({ url: this.dynamicDialogConfig.data.apiString, formData: $event }).subscribe(res => {
          this.alertService.showAlertNotification({ html: res.message });
          this.dynamicDialogRef.close(res);
        });
      } else {
        this.crudService.putData({ url: this.dynamicDialogConfig.data.apiString, id: $event.value.id, formData: $event }).subscribe(res => {
          this.alertService.showAlertNotification({ html: res.message });
          this.dynamicDialogRef.close(res);
        });
      }
    } else {
      this.dynamicDialogRef.close($event);
    }
  }
}